import moment from "moment-timezone";

export function formatTiktokData(data) {
    const chart_name = data?.chart_name;
    const resp_data = data?.response;
    // const isAverage = data?.isAverage;
    // const durationPeriod = +data?.durationGap?.toFixed(0) + 1;

    if (Object.keys(resp_data).length === 0) {
        return resp_data;
    }
    if (chart_name === "tiktok_page_follower_change") {
        let data = resp_data?.follower_growth_overtime || [];
        let lineChartData = data.map((ele) => {
            // return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
            return { x: +moment(ele.data_at).format("x"), y: ele.total };
        });
        return { lineChartData: lineChartData };
    }

    if (chart_name === "TKRecentPosts") {
        let recentPosts = [];
        let data;
        data = resp_data.filter((item) => {
            // console.log("validte", item?._source);
            return item?._source?.post?.post_subtype !== "ads";
        });
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        data?.forEach((item) => {
            let image_url = "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
            let profile_pic =
                "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post_author?.media[0].folder + "/" + item?._source?.post_author?.media[0].name;
            let totalEngagement =
                item?._source.post?.engagement_values?.like_count +
                item?._source.post?.engagement_values?.comment_count +
                item?._source.post?.engagement_values?.share_count;

            // + item?._source.post?.engagement_values?.share_count +
            // item?._source.post?.engagement_values?.view_count;
            if (item) {
                recentPosts.push({
                    gender: item?._source?.post_author?.gender,
                    profile_pic: profile_pic,
                    username: item?._source?.handlers[0].value,
                    post_type: item?._source?.post?.media[0].type,
                    image_url: image_url,
                    content: item?._source?.post?.content,
                    title: item?._source?.post?.title,
                    post_url: item?._source?.post?.url,
                    created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                    hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                    engagement: item?._source?.post?.engagement_values,
                    impact: item?._source.impact_value,
                    totalEngagement: totalEngagement,
                });
            }
        });

        recentPosts = recentPosts.slice(0, 10);
        return recentPosts;
    }
    if (
        // TotalFollowers
        chart_name === "total_engagement" ||
        chart_name === "total-reach" ||
        chart_name === "total-page-views" ||
        chart_name === "total-posts" ||
        chart_name === "total-posts-likes" ||
        chart_name === "total-posts-comments" ||
        chart_name === "total-posts-views" ||
        chart_name === "total-followers"
    ) {
        let { data: presentDurationData } = resp_data.find((r) => r.name === "presentDurationData");
        let { data: previousDurationData } = resp_data.find((r) => r.name === "previousDurationData");

        let obj = {
            presentDurationData: null,
            previousDurationData: null,
            nodata: false,
            percentage_change: null,
            durationGap: +data?.durationGap?.toFixed(0) + 1,
        };
        const aggsArr = ["comment-count-stats", "like-count-stats", "share-count-stats", "view-count-stats"];
        switch (chart_name) {
            case "total-followers":
                obj.nodata = presentDurationData?.data?.follower_growth_overtime[0]?.total == 0;

                // obj.presentDurationData = presentDurationData.data?.follower_growth_overtime?.reduce((acc, curr) => {
                //     return acc + curr?.total;
                // }, 0);
                obj.presentDurationData = presentDurationData?.data?.follower_growth_overtime.at(-1)?.total;
                obj.previousDurationData = previousDurationData?.data?.follower_growth_overtime.at(-1)?.total;
                // obj.previousDurationData = previousDurationData.data?.follower_growth_overtime?.reduce((acc, curr) => {
                //     return acc + curr?.total;
                // }, 0);

                break;

            case "total-reach":
                obj.nodata = presentDurationData?.hits?.total == 0;

                obj.presentDurationData = presentDurationData?.aggregations?.["total_estimated_reach"]?.value;
                obj.previousDurationData = previousDurationData?.aggregations?.["total_estimated_reach"]?.value;
                obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);
                // obj.avg_val = +(obj.presentDurationData / obj.durationGap); // avg value based on duration gap
                break;

            case "total_engagement": {
                let presentSum = 0;
                let prevSum = 0;

                aggsArr.forEach((aggsVal) => {
                    presentSum += presentDurationData?.aggregations?.[aggsVal]?.sum;
                    prevSum += previousDurationData?.aggregations?.[aggsVal]?.sum;
                });
                obj.nodata = presentDurationData?.hits?.total == 0;
                obj.presentDurationData = presentSum;
                obj.previousDurationData = prevSum;
                obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);

                break;
            }

            case "total-posts":
                obj.nodata = presentDurationData?.hits?.total == 0;
                obj.presentDurationData = presentDurationData?.hits?.total;
                obj.previousDurationData = previousDurationData?.hits?.total;
                obj.avg_val = +(obj.presentDurationData / obj.durationGap).toFixed(1); // avg value based on duration gap
                break;

            case "total-posts-likes":
                obj.nodata = presentDurationData?.hits?.total == 0;

                obj.presentDurationData = presentDurationData?.aggregations?.["like-count-stats"]?.sum;
                obj.previousDurationData = previousDurationData?.aggregations?.["like-count-stats"]?.sum;
                obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);
                break;

            case "total-posts-comments":
                obj.nodata = presentDurationData?.hits?.total == 0;

                obj.presentDurationData = presentDurationData?.aggregations?.["comment-count-stats"]?.sum;
                obj.previousDurationData = previousDurationData?.aggregations?.["comment-count-stats"]?.sum;
                obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);
                break;
            case "total-posts-views":
                obj.nodata = presentDurationData?.hits?.total == 0;

                obj.presentDurationData = presentDurationData?.aggregations?.["view-count-stats"]?.sum;
                obj.previousDurationData = previousDurationData?.aggregations?.["view-count-stats"]?.sum;
                obj.avg_val = +presentDurationData?.aggregations?.["view-count-stats"]?.avg;
                //  (obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);
                break;

            default:
                break;
        }

        if ((obj.presentDurationData && !(obj.presentDurationData > 0)) || obj.presentDurationData === 0) obj.nodata = true;

        if (!obj.nodata) {
            if (obj.previousDurationData !== 0)
                obj.percentage_change = +(((obj.presentDurationData - obj.previousDurationData) / obj.previousDurationData) * 100).toFixed(2);
        }

        return obj;
    }
    if (chart_name === "audience_metrics_by_country") {
        let barChartData = [];
        let pieChartData = [];
        let LocationWithData = [];
        // let countryData = resp_data || {};
        let countryData = resp_data?.aggregations?.["country-wise-breakup"]?.buckets || [];

        // const masterLocationList = countryColorList;

        let LocationKeys = [];
        let hashMap = [];
        let locationHashMap = {};

        countryData.forEach((ele) => {
            hashMap.push({ name: ele.key, count: ele.doc_count });
            LocationKeys.push(ele.key);
            locationHashMap[ele.key] = ele.key;
        });

        // for (const key in countryData) {
        //     console.log("savdsavas", hashMap, key, countryData);
        //     // let count = 0;
        //     // countryData[key].forEach((ele) => {
        //     //     count += ele.count;
        //     // });
        //     hashMap.push({ name: key, count: doc_count });
        //     LocationKeys.push(key);
        //     console.log("savdsavas end", hashMap, key);
        // }

        // let locationHashMap = {};
        // let locationHashMap = LocationKeys;
        // LocationKeys.forEach((short_name) => {
        //     let country = masterLocationList.find((ele) => ele.code.toLowerCase() == short_name);
        //     if (country) {
        //         locationHashMap[short_name] = country.country;
        //     }
        // });

        let sortedHashMap = hashMap.sort((a, b) => {
            if (a.count > b.count) {
                return -1;
            } else return 1;
        });

        let totalCount = sortedHashMap.reduce((acc, curr) => {
            return acc + curr.count;
        }, 0);

        sortedHashMap.forEach((ele, ind) => {
            if (ind < 9) {
                let obj = {};
                // obj["name"] = locationHashMap[ele.name];
                obj["name"] = ele.name;
                obj["data"] = [];
                let dataObj = {};
                // dataObj["name"] = locationHashMap[ele.name];
                dataObj["name"] = ele.name;
                dataObj["y"] = ele.count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                // pieChartData.push({ name: locationHashMap[ele.name], y: ele.count });
                pieChartData.push({ name: ele.name, y: ele.count });
                // LocationWithData.push(locationHashMap[ele.name]);
                LocationWithData.push(ele.name);
            }
        });

        if (sortedHashMap.length > 9) {
            let count = 0;
            sortedHashMap.forEach((ele, ind) => {
                if (ind > 8) {
                    count += ele.count;
                }
            });
            if (count > 0) {
                let obj = {};
                obj["name"] = "Others";
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = "Others";
                dataObj["y"] = count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                pieChartData.push({ name: "Others", y: count });
                barChartData.push(obj);
                LocationWithData.push("Others");
            }
        }
        barChartData = barChartData.sort((a, b) => {
            if (a.data[0].y > b.data[0].y) {
                return 1;
            }
            if (a.data[0].y < b.data[0].y) {
                return -1;
            } else return 0;
        });

        return {
            barChartData: barChartData,
            pieChartData: pieChartData,
            LocationWithData: LocationWithData,
            downLoadData: sortedHashMap,
            allLocation: locationHashMap,
        };
    }
    if (chart_name === "tiktok_posts_overtime") {
        let data = { nodata: resp_data.hits.total === 0, lineChartData: [] };
        let total = 0;
        let tz = JSON.parse(localStorage.company).user_timezone_name;

        data.lineChartData = resp_data.aggregations.conversation_over_time.buckets.map((d) => {
            total += d.doc_count;
            let date = +moment(d.key).tz(tz).format("x");
            return [date, d.doc_count];
        });

        data.nodata = total === 0;

        return data;
    }
    if (chart_name === "tiktok_post_likes") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            likes_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        resp_data.aggregations?.reactions_datewise_breakdown?.buckets.forEach((likes) => {
            let d = +moment(likes.key).tz(tz).format("x");
            obj.likes_agg.push([d, likes.like_count.sum || 0]);

            total += likes.like_count.sum;
        });

        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "tiktok_post_comments") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            comments_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations?.reactions_datewise_breakdown?.buckets.forEach((comments) => {
            let d = +moment(comments.key).tz(tz).format("x");
            obj.comments_agg.push([d, comments.comment_count.sum || 0]);
            total += comments.comment_count.sum;
        });

        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "tiktok_post_impressions") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            impression_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        resp_data.aggregations.reactions_datewise_breakdown.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.impression_agg.push([d, views.view_count.sum || 0]);
            total += views.view_count.sum;
        });
        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);
        return obj;
    }
    if (chart_name === "tiktok_post_reach") {
        // console.log(resp_data);

        let obj = {
            nodata: resp_data.hits.total === 0,
            views_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations.conversation_over_time_estimated_reach.buckets.forEach((reach) => {
            let d = +moment(reach.key).tz(tz).format("x");
            obj.views_agg.push([d, reach.stats.sum || 0]);
            total += reach.stats.sum;
        });

        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "engagement_over_time") {
        let modifiedData = {
            nodata: resp_data.hits.total === 0,
            total_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        let total = 0;
        resp_data.aggregations.reactions_datewise_breakdown.buckets.forEach((obj) => {
            let d = +moment(obj.key).tz(tz).format("x");
            let sum_of_reaction = +obj.like_count?.sum + obj.comment_count?.sum + obj.share_count?.sum + obj.view_count?.sum;
            modifiedData.total_agg.push([d, sum_of_reaction || 0]);
            total += sum_of_reaction;
        });

        let totallength = resp_data.hits.total || 1;
        modifiedData.avg_value = +(total / totallength).toFixed(2);

        return modifiedData;
    }
    if (chart_name === "engagement_rate_over_time") {
        const engagementData = resp_data.find((obj) => obj.name === "engagementOverTime");
        const followersData = resp_data.find((obj) => obj.name === "followersOverTime");

        let modifiedData = {
            nodata: false,
            total_agg: [],
        };

        const total_agg = {};
        const followerData = {};

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        let total = 0;
        engagementData?.data?.aggregations?.reactions_datewise_breakdown.buckets.forEach((obj) => {
            let d = +moment(obj.key_as_string).tz(tz).format("x");
            let sum_of_reaction = +obj.like_count?.sum + obj.comment_count?.sum + obj.share_count?.sum + obj.view_count?.sum;
            // modifiedData.total_agg.push([d, sum_of_reaction || 0]);
            total_agg[d] = sum_of_reaction || 0;
        });

        const engagmentList = Object.values(total_agg);
        console.log("total_agg", engagmentList);

        followersData?.data?.follower_growth_overtime?.forEach((followersObj, ind) => {
            const date = +moment(followersObj.data_at).format("x");

            if (engagmentList[ind] && followersObj?.total !== 0) {
                followerData[date] = +(engagmentList[ind] / followersObj?.total || 0).toFixed(4);
                total += followerData[date];
            } else {
                followerData[date] = 0;
                // console.log("nottt founddd", date);
            }
        });
        modifiedData.total_agg = Object.entries(followerData).map(([k, v]) => [+k, v || 0]);
        modifiedData.nodata = engagementData?.data?.hits?.total === 0 || total === 0;

        return modifiedData;
    }
}
